var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForgotPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "forgot 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.1699 52.8984C41.7664 52.8984 43.0605 51.6043 43.0605 50.0078C43.0605 48.4114 41.7664 47.1172 40.1699 47.1172C38.5735 47.1172 37.2793 48.4114 37.2793 50.0078C37.2793 51.6043 38.5735 52.8984 40.1699 52.8984Z",
    fill: "#52682F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.8535 68.2186H13.8652C10.6775 68.2186 8.08398 65.6251 8.08398 62.4374V38.7342C8.08398 35.5464 10.6775 32.953 13.8652 32.953H55.4902C56.1484 32.953 56.6706 33.0111 57.0869 33.1303C58.6215 33.57 60.222 32.6823 60.6618 31.1476C61.1015 29.613 60.2138 28.0125 58.6792 27.5727C57.7378 27.303 56.6948 27.1719 55.4902 27.1719H52.0161V16.9775C52.0161 7.61607 44.2357 0 34.6724 0C25.109 0 17.3286 7.61607 17.3286 16.9775V27.1719H13.8652C7.48967 27.1719 2.30273 32.3588 2.30273 38.7344V62.4375C2.30273 68.8131 7.48967 74 13.8652 74H49.8535C51.45 74 52.7441 72.7059 52.7441 71.1094C52.7441 69.5129 51.45 68.2188 49.8535 68.2186ZM23.1099 16.9775C23.1099 10.8039 28.2968 5.78125 34.6724 5.78125C41.0479 5.78125 46.2349 10.8039 46.2349 16.9775V27.1719H23.1099V16.9775Z",
    fill: "#52682F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.3301 52.8984C30.9265 52.8984 32.2207 51.6043 32.2207 50.0078C32.2207 48.4114 30.9265 47.1172 29.3301 47.1172C27.7336 47.1172 26.4395 48.4114 26.4395 50.0078C26.4395 51.6043 27.7336 52.8984 29.3301 52.8984Z",
    fill: "#52682F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M71.6941 47.8702C71.6308 42.264 67.0504 37.7227 61.4294 37.7227C55.7693 37.7227 51.1641 42.3277 51.1641 47.988C51.1641 49.5845 52.4582 50.8786 54.0547 50.8786C55.6512 50.8786 56.9453 49.5845 56.9453 47.988C56.9453 45.5155 58.9569 43.5039 61.4295 43.5039C63.9022 43.5039 65.9136 45.5155 65.9136 47.988C65.9136 48.0143 65.9139 48.0405 65.9146 48.0665C65.8849 49.8365 64.8215 51.4212 63.1882 52.1184C60.3639 53.3245 58.5389 56.1101 58.5389 59.215V61.7148C58.5389 63.3113 59.833 64.6055 61.4295 64.6055C63.026 64.6055 64.3202 63.3113 64.3202 61.7148V59.215C64.3202 58.4291 64.7671 57.7305 65.4583 57.4354C69.249 55.8172 71.6976 52.1087 71.6966 47.9874C71.6966 47.9481 71.6957 47.9091 71.6941 47.8702Z",
    fill: "#52682F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M61.416 74C63.0125 74 64.3066 72.7058 64.3066 71.1094C64.3066 69.5129 63.0125 68.2188 61.416 68.2188C59.8196 68.2188 58.5254 69.5129 58.5254 71.1094C58.5254 72.7058 59.8196 74 61.416 74Z",
    fill: "#52682F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.4902 52.8984C20.0867 52.8984 21.3809 51.6043 21.3809 50.0078C21.3809 48.4114 20.0867 47.1172 18.4902 47.1172C16.8938 47.1172 15.5996 48.4114 15.5996 50.0078C15.5996 51.6043 16.8938 52.8984 18.4902 52.8984Z",
    fill: "#52682F"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassword);
export default __webpack_public_path__ + "static/media/forgot-password.a0f624fdca038ea5fa6305046b11a775.svg";
export { ForwardRef as ReactComponent };